import DialogController from "./dialog_controller";
import { EventToast, EventCheckUserLogin } from "../events";
import {
  simpleNotificationToast,
  withCallToActionNotificationToast
} from "../template/toast_notification";
import {
  getPortfolioNftContracts,
  addPortfolioNftContractRequest,
  removePortfolioNftContractRequest
} from "../routes/nft_portfolio";

export default class extends DialogController {
  static targets = ["solidStar"];

  connect() {
    getPortfolioNftContracts((res) => {
      if (res.status != 200) {
        this.userLoggedIn = false;
        this.solidStarTargets.forEach((star) => {
          star.href = "#";
          star.dataset.target = "#signInModal";
          star.dataset.toggle = "modal";
        });
        return false;
      }

      this.userLoggedIn = true;
      return true;
    }, (res) => {
      if (!res) {
        return;
      }
      this.nftPortfolios = res;
      this.solidStarTargets.forEach((star) => {
        if (this._hasNftPortfolio(star.dataset.nftContractId)) {
          this.markStar(star);
        }
      });
    });

    window.addEventListener(EventCheckUserLogin, (e) => {
      this.userLoggedIn = e.detail.userLoggedIn;
    });
  }

  trigger(event) {
    const star = event.currentTarget;
    this._toggleNftPortfolioList(star);
  }

  _toggleNftPortfolioList(star) {
    const nftPortfolioDropdown = star.previousElementSibling;
    let dropDownContent = `
      <div class="d-lg-none ml-1 row mb-3">
        <button type="button" class="close float-left">
          <span class="text-5xl font-light" style="color: #707070;">&times;</span>  
        </button>
      </div>
    `;

    if (!this.nftPortfolios) {
      return;
    }

    this.nftPortfolios.forEach((nftPortfolio) => {
      dropDownContent += this._initNftPortfolioItem(star.dataset, nftPortfolio);
    });

    nftPortfolioDropdown.innerHTML = dropDownContent;
  }

  _initNftPortfolioItem(attrs, nftPortfolio) {
    const nftContractId = parseInt(attrs.nftContractId);
    const addedToNftPortfolio = (nftPortfolio.nft_contract_ids.indexOf(nftContractId) > -1);
    const dataAction = addedToNftPortfolio ? "click->nft-favorites#unfavorite" : "click->nft-favorites#favorite";
    const checkStatus = addedToNftPortfolio ? "d-block" : "tw-hidden";
    const unCheckStatus = !addedToNftPortfolio ? "d-block" : "tw-hidden";
    const fontBold = addedToNftPortfolio ? "font-bold" : "font-normal";
    const removeContractModalConfirm = addedToNftPortfolio ? "unfavorite_nft_contract = true" : ""

    return `
      <div class="row cursor-pointer pt-3 pl-2 ml-0 pb-3 dropdown-item pr-0" \
        @click="${removeContractModalConfirm}" \
        data-confirm-modal="${attrs.confirmModal}" \
        data-confirm-button="${attrs.confirmButton}" \
        data-toast-success-message="${attrs.toastSuccessMessage}" \
        data-nft-portfolio-id="${nftPortfolio.id}" \
        data-nft-portfolio-title="${nftPortfolio.title}" \
        data-nft-contract-id="${nftContractId}" \
        data-nft-contract-slug="${attrs.nftContractSlug}" \
        data-nft-contract-image="${attrs.nftContractImage}" \
        data-nft-contract-symbol="${attrs.nftContractSymbol}" \
        data-action="${dataAction}" \
        data-refresh="${attrs.refresh}" \
        data-source="${attrs.source}"
        type="button">
        <div class="${checkStatus}"><span class="fas fa-check float-right text-green" /></div>
        <div class="${unCheckStatus}"><span class="far fa-plus float-right" /></div>
        <div class="col-9 pl-0 text-left text-truncate ${fontBold}">${nftPortfolio.title}</div>
      </div>
    `;
  }

  markStar(currentStar) {
    currentStar.classList.remove("far");
    currentStar.classList.add("fas", "star-color");
  }

  unmarkStar(currentStar) {
    currentStar.classList.remove("fas", "star-color");
    currentStar.classList.add("far");
  }

  _hasNftPortfolio(nft_contract_id) {
    const parsedNftContractId = parseInt(nft_contract_id);
    return (this.nftPortfolios.some((nftPortfolio) => nftPortfolio.nft_contract_ids.indexOf(parsedNftContractId) > -1));
  }

  _removeContractFromPortfolio(nftPortfolioId, nftContractId) {
    const parsedNftContractId = parseInt(nftContractId);
    const parsedNftPortfolioId = parseInt(nftPortfolioId);

    for (const i in this.nftPortfolios) {
      const nftPortfolio = this.nftPortfolios[i];

      if (nftPortfolio.id == parsedNftPortfolioId) {
        const nftContractIndex = nftPortfolio.nft_contract_ids.indexOf(parsedNftContractId);
        this.nftPortfolios[i].nft_contract_ids.splice(nftContractIndex, 1);
      }
    }
  }


  _nftContract(nftContract) {
    const nftContractAttributes = [
      "nftContractId", "nftContractSymbol", "nftContractImage",
      "toastSuccessMessage", "nftContractSlug", "source"
    ];

    return nftContractAttributes.reduce((result, key) => {
      result[key] = nftContract.dataset[key];
      return result;
    }, {});
  }

  favorite(event) {
    if (!this.userLoggedIn) {
      return;
    }

    const nftPortfolioTarget = event.currentTarget;
    const nftPortfolioId = nftPortfolioTarget.dataset.nftPortfolioId;
    const nftPortfolioTitle = nftPortfolioTarget.dataset.nftPortfolioTitle;
    const nftContract = this._nftContract(nftPortfolioTarget);
    const nftPortfolioDropdown = nftPortfolioTarget.parentNode;
    const starTarget = nftPortfolioDropdown.nextElementSibling;

    this._favoriteAction(nftContract, starTarget, nftPortfolioId, nftPortfolioTitle);
  }

  _favoriteAction(nftContract, starTarget, nftPortfolioId, nftPortfolioTitle) {
    const params = {
      nftPortfolioId: nftPortfolioId,
      nftContractId: nftContract.nftContractId,
      source: nftContract.source
    };

    addPortfolioNftContractRequest(params, (res) => {
      this._updateNftPortfolio(res.nft_portfolio_id, res.nft_contract_id);
      this.markStar(starTarget);

      this._showNotificationToast(nftContract, nftPortfolioTitle);
    });
  }

  _updateNftPortfolio(nftPortfolioId, nftContractId) {
    const parsedNftContractId = parseInt(nftContractId);
    const parsedNftPortfolioId = parseInt(nftPortfolioId);

    for (const i in this.nftPortfolios) {
      const nftPortfolio = this.nftPortfolios[i];

      if (nftPortfolio.id == parsedNftPortfolioId) {
        this.nftPortfolios[i].nft_contract_ids = nftPortfolio.nft_contract_ids || [];
        this.nftPortfolios[i].nft_contract_ids.push(parsedNftContractId);
      }
    }
  }

  unfavorite(event) {
    if (!this.userLoggedIn) {
      return;
    }

    const nftPortfolioTarget = event.currentTarget;
    const nftContract = this._nftContract(nftPortfolioTarget);
    const nftPortfolioId = nftPortfolioTarget.dataset.nftPortfolioId;
    const nftPortfolioDropdown = nftPortfolioTarget.parentNode;
    const starTarget = nftPortfolioDropdown.nextElementSibling;
    const unfavoriteConfirmModal = $(`#${nftPortfolioTarget.dataset.confirmModal}`)
    const modal = {
      confirmModal: unfavoriteConfirmModal,
      confirmButton: unfavoriteConfirmModal.find(`#${nftPortfolioTarget.dataset.confirmButton}`)
    };

    this._unfavoriteAction(nftContract, starTarget, modal, nftPortfolioId);
  }

  _unfavoriteAction(nftContract, starTarget, modal, nftPortfolioId) {
    const unfavoriteConfirmButton = modal.confirmButton;

    this._confirmationDialog(
      () => {
      },
      unfavoriteConfirmButton,
      () => {
        this._unfavoriteActionCallback(nftContract, nftPortfolioId, starTarget);
      }
    );
  }

  _unfavoriteActionCallback(nftContract, nftPortfolioId, starTarget) {
    const params = {
      nftContractId: nftContract.nftContractId,
      source: nftContract.source,
      nftPortfolioId: nftPortfolioId
    };

    removePortfolioNftContractRequest(params, (res) => {
      this._removeContractFromPortfolio(res.nft_portfolio_id, res.nft_contract_id);

      if (!this._hasNftPortfolio(nftContract.nftContractId)) {
        this.unmarkStar(starTarget);
      }

      this._showUnfavoriteToast(nftContract, res.nft_portfolio_title);

      // For NFT Portfolio show page table
      if (params.source === "nft_portfolio_star_button") {
        window.location.reload();
      }
    });
  }

  _showNotificationToast(nftContract, nftPortfolioTitle) {
    const nftPortfolioPath = `/${document.body.dataset.locale}/nft-portfolio`;
    const hyperlinkText = I18n.t("portfolio.view", { portfolioTitle: nftPortfolioTitle });

    window.dispatchEvent(
      new CustomEvent(EventToast, {
        detail: {
          notice: withCallToActionNotificationToast(
            nftPortfolioPath,
            nftContract.toastSuccessMessage,
            hyperlinkText
          )
        }
      })
    );
  }

  _showUnfavoriteToast(nftContract, nftPortfolioTitle) {
    const nftContractSymbol = nftContract.nftContractSymbol.toUpperCase();

    window.dispatchEvent(
      new CustomEvent(EventToast, {
        detail: {
          notice: simpleNotificationToast(I18n.t("portfolio.unfavorite", {
            symbol: nftContractSymbol,
            portfolioTitle: nftPortfolioTitle
          }))
        }
      })
    );
  }
}
